import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { IFileDetailsModal } from '@shared/interfaces/file/file-details-modal';

@Component({
  selector: 'app-print-details-modal',
  templateUrl: './print-details-modal.component.html',
  styleUrls: ['./print-details-modal.component.scss']
})
export class PrintDetailsModalComponent implements OnInit {
  modalData!: IFileDetailsModal;

  constructor(protected dialogRef: NbDialogRef<PrintDetailsModalComponent>) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

}
